import { Spin } from "antd"
import s from './spinner.module.scss'

export const NewSpinner = () => {
    return(
        <div className={s.spinner_wrapper}>
        <Spin size="large" />
        </div>
    )
}